<template>
    <div>
        <!-- Mapa Google -->
        <GmapMap
            ref="map"
            :zoom="18"
            :options="{
                zoomControl: true,
                maxZoom: 20,
                mapTypeControl: false,
                scaleControl: false,
                streetViewControl: false,
                rotateControl: false,
                fullscreenControl: false,
                scrollwheel: false,
                disableDefaultUi: false,
            }"
            :center="geolocation"
            map-type-id="roadmap"
            style="height: 380px; width: 100%"
            @zoom_changed="updateZoom"
        >
            <!-- Círculo desenhado no mapa -->
            <GmapCircle :center="circle.center" :radius="circle.radius" :options="circleOptions" />

            <!-- Marcador -->
            <GmapMarker
                :position="{
                    lat: geolocation.lat ? Number(geolocation.lat) : 0,
                    lng: geolocation.lng ? Number(geolocation.lng) : 0,
                }"
            />
        </GmapMap>
    </div>
</template>

<script>
import * as VueGoogleMaps from 'vue2-google-maps'

export default {
    props: ['location', 'radius'],
    watch: {
        location: function (newLocation) {
            if (Array.isArray(newLocation) && newLocation.length === 2) {
                this.geolocation = { lat: Number(newLocation[0]), lng: Number(newLocation[1]) }
                this.circle.center = this.geolocation
                this.fitGeofence()
            }
        },
        radius: function (newRadius) {
            this.circle.radius = Number(newRadius) || 0
            this.fitGeofence()
        },
    },
    components: {
        GmapMap: VueGoogleMaps.Map,
        GmapCircle: VueGoogleMaps.Circle,
        GmapMarker: VueGoogleMaps.Marker,
    },
    data() {
        return {
            zoom: 12,
            geolocation: { lat: 0, lng: 0 }, // Inicialização como objeto
            circle: {
                center: { lat: 0, lng: 0 }, // Inicialização como objeto
                radius: 0,
            },
            circleOptions: {
                strokeColor: '#FF0000', // Cor da borda
                strokeOpacity: 0.8, // Opacidade da borda
                strokeWeight: 2, // Espessura da borda
                fillColor: '#FF0000', // Cor do preenchimento
                fillOpacity: 0.12, // Destaca a área configurada sem ocultar as ruas
            },
            markers: [],
        }
    },
    methods: {
        updateZoom() {
            const map = this.$refs.map.$mapObject
            this.zoom = map.getZoom()
        },
        getLocation() {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                    position => {
                        this.geolocation = {
                            lat: position.coords.latitude,
                            lng: position.coords.longitude,
                        }
                        this.circle.center = this.geolocation
                    },
                    () => {
                    },
                )
            }
        },
        fitGeofence() {
            const apply = map => {
                if (!map || !Number.isFinite(this.geolocation.lat) || !Number.isFinite(this.geolocation.lng)) return
                if (this.circle.radius <= 0) return
                // Show the entire configured area, including small radii hidden under the pin.
                const latitudeDelta = this.circle.radius / 111320
                const longitudeDelta = latitudeDelta / Math.max(0.01, Math.cos(this.geolocation.lat * Math.PI / 180))
                map.fitBounds({
                    north: Math.min(90, this.geolocation.lat + latitudeDelta),
                    south: Math.max(-90, this.geolocation.lat - latitudeDelta),
                    east: Math.min(180, this.geolocation.lng + longitudeDelta),
                    west: Math.max(-180, this.geolocation.lng - longitudeDelta),
                }, 45)
            }
            this.$nextTick(() => {
                const component = this.$refs.map
                if (component?.$mapObject) apply(component.$mapObject)
                else if (component?.$mapPromise) component.$mapPromise.then(apply)
            })
        },
    },
    mounted() {
        if (Array.isArray(this.location) && this.location[0] === 0 && this.location[1] === 0) {
            this.getLocation()
        } else if (Array.isArray(this.location)) {
            this.geolocation = { lat: this.location[0], lng: this.location[1] }
            this.circle.center = this.geolocation
            this.circle.radius = Number(this.radius) || 0
            this.fitGeofence()
        }
    },
}
</script>
